import BaseStore from "libs/BaseStore";
import { action, computed, observable } from "mobx";

interface ISession {
  id_token: string;
  session_state: string;
  access_token: string;
  refresh_token: string;
  token_type: string;
  scope: string;
  profile: {
    s_hash: string;
    sid: string;
    sub: string;
    auth_time: number;
    idp: string;
    name: string;
    id: string;
    username: string;
    fullname: string;
    email: string;
    phone: string;
    status: string;
    amr: string;
    tenant_id: string;
    application_id: string;
    isemailconfirmed: string;
  };
  expires_at: number;
  selected_tenant_id: string;
}

export default class RootStore extends BaseStore {
  constructor(props) {
    super(props);
  }

  @observable layoutSubscriptionTopic: string = null;
  @observable sessionInfo: ISession = null;
  @observable renewToken = (user: any) => { };

  @action
  refreshToken = (callback) => {
    try {
      this.renewToken(user => {
        this.sessionInfo = user;
        callback(null, `Bearer ${this.sessionInfo?.access_token}`);
      });
    } catch (err) {
      alert(err.message);
    }
  }
}
